import React from "react";

import Page from "~/models/page";

type Props = {
  page: Page;
  sd: any;
  children?: any;
};

function SEO({ page, sd, children }: Props) {
  return (
    <React.Fragment>
      <title>{page.metaTitle}</title>
      <meta
        name="description"
        content={page.description || page.excerpt?.slice(0, 140)}
      />
      {page.noindex && <meta name="robots" content="noindex, nofollow" />}
      <link
        rel="canonical"
        href={`${process.env.GATSBY_SITE_URL}${page.url.pathname}`}
      />
      <meta name="format-detection" content="telephone=no" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=5"></meta>
      <meta name="og:title" content={page.metaTitle} />
      <meta name="og:type" content="website" />
      <meta
        name="og:image"
        content={
          page.imageUrls
            ? page.imageUrls.ogp.publicURL
            : `${process.env.GATSBY_SITE_URL}/images/ogp.png`
        }
      />
      <meta name="og:image:width" content="1200" />
      <meta name="og:image:height" content="630" />
      <meta
        name="og:url"
        content={`${process.env.GATSBY_SITE_URL}${page.url.pathname}`}
      />
      <meta
        name="og:description"
        content={page.description || page.excerpt?.slice(0, 140)}
      />
      <meta name="robots" content="max-image-preview:large" />
      <meta
        name="og:site_name"
        content="株式会社Artefact"
      />
      <meta name="twitter:title" content={page.metaTitle} />
      <meta
        name="twitter:description"
        content={page.description || page.excerpt?.slice(0, 140)}
      />
      <meta
        name="twitter:image"
        content={
          page.imageUrls
            ? page.imageUrls.ogp.publicURL
            : `${process.env.GATSBY_SITE_URL}/images/ogp.png`
        }
      />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="" />

      <link rel="icon" href="/images/favicon-16x16.png" type="image/png" />
      <link rel="icon" href="/images/favicon-32x32.png" type="image/png" />
      <link
        rel="shortcut icon"
        href="/images/favicon-64x64.png"
        type="image/png"
      />

      {children}
    </React.Fragment>
  );
}

export default SEO;
